import { App } from 'vue'
import Tab from '../tabs/LpTab.vue'

Tab.install = (Vue: App) => {
  Vue.component(Tab.name, Tab)
}

export default Tab
